


















































import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { attachmentService, dealService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
})
 class DealPendingAttachmentsPage extends Base {
  public loading: boolean = false;
  public dealPendingAttachmentLoader: boolean = false;
  public attachments: any = [{comment:"test"}];
  public paginations = new PaginationModel('id');
  public dealNumberModel :string = "";
  public moveToDealLoading: boolean = false; 
  // Dialog
  public removePendingAttachmentDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.deletePendingAttachment();
    },
  };
    // Dialog
    public pendingAttachmentMoveToDealDailog: IDialogOption = {
    width: 400,
    title: "Move To Deal",
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: "Move To Deal",
    },
    onAction: (): void => {
      this.updateDealPendingAttachment();
    },
  };
  public pendingAttachmentToRemove: any;
  public pendingAttachmentMoveToDeal:any;
  public actions: any[] = [
  {
        type: 'button',
        icon: 'fa fa-eye',
        title: "View Attachment",
        loading: false,
        action: (model: any, action: any) => {
          this.viewAttachment(model.id, action);
        },
      },    
    {
      type: 'button',
      icon: 'fa fa-arrows',
      title: 'Move',
      action: (model: any) => {
        this.confirmUpdatePendingAttachment(model);
      },
    },
    {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: 'Delete',
        color: 'error',
        visible: (model: any) => true,
        action: (model: any) => {
          this.confirmDeletePendingAttachment(model);
        },
      },
    
  ];
  public headers: VHeaders[] = [
   {
      text: "Upload Time",
      align: 'left',
      value: 'createdAt',
      fieldType: 'date',
      sortable: true,
    },
    {
      text: "User Name",
      align: 'left',
      value: 'customerName',
    },
    
    {
      text: "Comment",
      align: 'left',
      value: 'comment',
    },
    
    {
      text: "Actions",
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('dealAttachment.btnBackToList') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('dealAttachment.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'deals');
    
    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.getDealPendingAttachments();
  }
  public async getDealPendingAttachments(){
    try {
      this.loading = true;
      this.attachments = [];
      let reponse = await dealService.getDealPendingAttachments(this.paginations);
     this.attachments = reponse.results;
     this.paginations.totalItems = reponse.total;
    }
    catch
    {
      this.showAlert(false, this.$t('dealAttachment.alertGetAttachment'));
    } finally {
      this.loading = false;
    }
  }
  public backToList() {
    if (history.state && history.length > 1) {
      //this.$router.back();
      history.back();
    } else {
      this.$router.push({ name: 'app.deals' });
    }
  }
  public confirmDeletePendingAttachment(model) {
    this.removePendingAttachmentDialog.model = true;
    this.pendingAttachmentToRemove = model;
  }
  public confirmUpdatePendingAttachment(model) {
    this.pendingAttachmentMoveToDealDailog.model = true;
    this.pendingAttachmentMoveToDeal = model;
  }
  public async deletePendingAttachment(): Promise<void> {
    try {
      this.removePendingAttachmentDialog.loading = true;
      await dealService.DeleteDealPendingAttachments(
        this.pendingAttachmentToRemove.id
      );
      this.showAlert(true, 'Pending Attachment deleted successfully');
    } finally {
      this.removePendingAttachmentDialog.model = false;
      this.removePendingAttachmentDialog.loading = false;
      this.getDealPendingAttachments();
    }
  }
  public updatePaging(paging: any) {
    this.paginations = paging;
    this.getDealPendingAttachments();
  }
  public async updateDealPendingAttachment(){
    if (!(await this.validateFormByScope('dealNumber'))) {
      return;
    }
    try {
      this.pendingAttachmentMoveToDealDailog.loading = true;
      await dealService.updateDealPendingAttachment(this.pendingAttachmentMoveToDeal.id,this.dealNumberModel
      );
      this.showAlert(true, 'Pending Attachment Moved successfully');
    } finally {
      this.pendingAttachmentMoveToDealDailog.model = false;
      this.pendingAttachmentMoveToDealDailog.loading = false;
      this.getDealPendingAttachments();
    }

  }

  public async viewAttachment(
    attachmentId: string,
    action: any
  ): Promise<void> {
    try {
      action.loading = true;
          this.dealPendingAttachmentLoader = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
          this.dealPendingAttachmentLoader = false;
    }
  }
}
export default DealPendingAttachmentsPage;
